import React, { memo, useState } from 'react';
import { CompanyLocationMap, NoData, Select } from '@components';
import { yellowAnchor, blueAnchor, redAnchor } from '@model';
import { removeValueFromSearchParam, setURLSearchParam } from '@utils/history';
import { deepCopy } from '@utils/common';
import { useSelector } from 'react-redux';
import { Tooltip } from 'antd';
// import '@style/modules/analysis/analysisRight.scss';
import '../../../../styles/modules/analysis/analysisRight.scss';
import { useHistory } from 'react-router-dom';
import searchParamKeys from '@model/searchParamKeys';
import './styles.scss';

const ALL_COMPANY = 'All';
const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });
const getCountryNameByCtryAbr = (abr) => {
  try {
    return regionNames.of(abr);
  } catch (e) {
    return abr;
  }
};

function HeadCount({ data, resourceId, isSingleCompany = false }) {
  const { eh } = data;

  const [filteredData, setFilteredData] = useState(deepCopy(eh));
  const [isShowAll, setIsShowAll] = useState(true);

  const { buyerLabel, targetLabel } = useSelector(({ common }) => ({
    buyerLabel: common.projectCompanyInfo.buyerLabel,
    targetLabel: common.projectCompanyInfo.targetLabel,
  }));

  const countries = eh
    .reduce((acc, e) => acc.concat(e.locations || []), [])
    .reduce((accCs, location) => {
      const cCode = location.country;
      if (cCode && !accCs.includes(cCode)) {
        return [...accCs, cCode];
      }
      return accCs;
    }, [])
    .map((e) => ({
      name: getCountryNameByCtryAbr(e),
      value: e,
    }))
    .sort((l, r) => (l.name > r.name ? 1 : -1));

  const handleSelectChange = (value) => {
    if (value === ALL_COMPANY) {
      setFilteredData(deepCopy(eh));
      setIsShowAll(true);
      return;
    }

    const dataFilteredByCountryCode = deepCopy(eh).map((company) =>
      Object.assign(company, {
        locations: company.locations.filter((l) => l.country === value),
      }),
    );

    dataFilteredByCountryCode.forEach((company) => {
      company.officeNum = company.locations.length;
      company.countryNum = 1;
    });

    setIsShowAll(false);
    setFilteredData(dataFilteredByCountryCode);
  };

  const hasNoData = filteredData.every((obj) => obj.isManualInput);

  const [expand, setExpand] = useState(false);
  const history = useHistory();

  const toggleExpand = () => {
    setExpand(!expand);
    if (!expand) {
      setURLSearchParam(history, {
        [searchParamKeys.expand]: true,
      });
    } else {
      removeValueFromSearchParam(history, [searchParamKeys.expand]);
    }
  };

  return (
    <div
      className={`analysis-right-wrapper employee-headcount ${
        expand && 'full-screen'
      }`}
    >
      <div
        className={`title expand-box ${
          expand ? 'full-screen-title no-border' : 'title-no-bottom-border'
        }`}
      >
        <div>Employee Headcount</div>
        {/*{hasNoData ? null : (*/}
        {/*  <ExpandButton*/}
        {/*    onClick={toggleExpand}*/}
        {/*    initialExpand={false}*/}
        {/*    scrollPageFooter*/}
        {/*  />*/}
        {/*)}*/}
      </div>
      <div className="bottom">
        {hasNoData ? (
          <NoData />
        ) : (
          <>
            <div className="info-area">
              <div className="country-select-wrapper">
                <span className="select-name-country">country</span>
                <Select
                  defaultValue={ALL_COMPANY}
                  onSelect={handleSelectChange}
                  className="emp-hc-country-select"
                  dropdownClassName="emp-hc-country-dropdown"
                  options={[
                    { name: ALL_COMPANY, value: ALL_COMPANY },
                    ...countries,
                  ]}
                  listHeight="9rem"
                />
              </div>
              <div className="compare-square-wrapper">
                {filteredData.map((curr, i) => {
                  if (curr.isManualInput) {
                    curr.officeNum = '-';
                    curr.countryNum = '-';
                  }
                  return (
                    <div key={`key-${i}`} className="compare-square">
                      <div className="name">
                        <Tooltip
                          placement="top"
                          getPopupContainer={() =>
                            document.querySelector('.rightContent')
                          }
                          title={curr.companyName || '-'}
                        >
                          {curr.companyName || '-'}
                        </Tooltip>
                      </div>
                      <div className="placeholder-wrapper">
                        <div className="a-1.5rem-high-place-holder" />
                      </div>
                      <div className="office">{curr.officeNum} Offices</div>
                      {isShowAll ? (
                        <div className="bottom-hint">
                          across{' '}
                          <div className="inline-div">
                            <span> {curr.countryNum}</span>
                            Countries
                          </div>
                        </div>
                      ) : null}
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="map-area">
              <CompanyLocationMap locationsInfo={filteredData} />
              <div className="map-legend">
                <img src={yellowAnchor} alt="client" />
                {buyerLabel}
                {isSingleCompany ? null : (
                  <>
                    <img src={blueAnchor} alt="target" />
                    {targetLabel}
                    <img src={redAnchor} alt="mixure" />
                    {`${buyerLabel}&${targetLabel}`}
                  </>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default memo(HeadCount);
